export default "__VITE_ASSET__e7ff72ef__"